/**
 * Single source of truth for the Skalx brand + semantic seed colors — ported
 * by value from ebs-platform-web (`packages/shared/src/theme/seed.ts`).
 *
 * AntD derives its ENTIRE palette (hover / active / bg / border / focus, for
 * every component) from these seeds — see `getTheme` in
 * `theme.ts`. The CSS-var layer (`tokens.css`)
 * derives the `--brand-teal*` family from `colorPrimary` at runtime via
 * `applyBrandCssVars` in `./brandCssVars`.
 *
 * Change a brand colour HERE and nowhere else — both systems follow.
 *
 * `colorInfo` stays blue as a deliberate semantic split from the brand teal.
 */
export const brandSeed = {
  colorPrimary: '#0F766E',
  colorInfo: '#1E40FF',
  colorSuccess: '#22C55E',
  colorWarning: '#F97316',
  colorError: '#EF4444'
} as const
